import React from 'react';
import TableRow from './TableRow';
import { StyledTable, TH, OptionsText } from './styles';

export default function OpcionMultipleMobile({
  setSelectedOptions,
  multipleOptionsSelected,
  asignaciones,
  agrupadores, 
  questionIndex,
  reactivos,
  setAnswerData,
  answerData,
  tipoEvaluacion
}){
  const handleClick = (asignacion, res, val) => {

    if (!multipleOptionsSelected.includes(asignacion.id)){
      let auxselectionOptionsSelected=multipleOptionsSelected
      auxselectionOptionsSelected.push(asignacion.id)
      setSelectedOptions(auxselectionOptionsSelected);
    }

    const agrupadorActual = agrupadores.filter((agrupador) =>
      agrupador.reactivos.includes(reactivos[questionIndex]),
    )[0];

    const existeRespuesta = answerData.respuestas.filter(
      (respuesta) =>
        respuesta.respuesta === res && respuesta.valor_respuesta === val
    );
    if(existeRespuesta.length>0){
      let myRespuestas=[]
      answerData.respuestas.forEach(respuesta=>{
        if(respuesta.respuesta === res && respuesta.valor_respuesta === val){
        }else{
          myRespuestas.push(respuesta)
        }
        setAnswerData({
          ...answerData,
          respuestas:myRespuestas
        })
      })
      return
    }

    if (
      answerData.respuestas.find(
        (respuesta) =>
          respuesta.id_asignacion === asignacion.id &&
          respuesta.id_agrupador === agrupadorActual.id,
      )
    ) {
      const respuestasFiltradas = answerData.respuestas.filter(
        (respuesta) =>
          respuesta.respuesta !== res || respuesta.valor_respuesta !== val
      );

      setAnswerData({ 
        ...answerData,
        respuestas: [
          ...respuestasFiltradas,
          {
            id_agrupador: agrupadorActual.id,
            id_reactivo: reactivos[questionIndex].id,
            clave_materia: asignacion.clave,
            clave_docente: asignacion.clave_docente,
            id_asignacion: asignacion.id,
            respuesta: res,
            valor_respuesta: val,
          }
        ],
      });
    } else {
      setAnswerData({
        ...answerData,
        respuestas: [
          ...answerData.respuestas,
          {
            id_agrupador: agrupadorActual.id,
            id_reactivo: reactivos[questionIndex].id,
            clave_materia: asignacion.clave,
            clave_docente: asignacion.clave_docente,
            id_asignacion: asignacion.id,
            respuesta: res,
            valor_respuesta: val,
          },
        ],
      });
    }
  };

  const options = reactivos[questionIndex].opciones;

  return (
    <StyledTable>
      <thead>
        <tr>
          {
            tipoEvaluacion==='Opinion_Estudiantil' ?
            <>
              <TH>
                <p
                  style={{
                    fontSize: '13px',
                    fontWeight: '400',
                    textAlign: 'left',
                  }}>
                  Asignatura
                </p>
              </TH>
              <TH>
                <p
                  style={{
                    fontSize: '13px',
                    fontWeight: '400',
                    textAlign: 'left',
                  }}>
                  Docente
                </p>
              </TH>

            </>:null

          }
          {options.map(({ id, nombre }, i) => (
            <TH key={id} dark={i % 2 === 0}>
              <OptionsText>{nombre}</OptionsText>
            </TH>
          ))}
        </tr>
      </thead>
      <tbody>
        {asignaciones.map((asignacion) => (
          <TableRow
            tipoEvaluacion={tipoEvaluacion}
            multipleOptionsSelected={multipleOptionsSelected}
            key={asignacion.id}
            id={asignacion.id}
            asignatura={asignacion.nombre}
            docente={asignacion.docente}
            handleClick={(res, val) => handleClick(asignacion, res, val)}
            options={options}
            answerData={answerData}
            reactivos={reactivos}
            questionIndex={questionIndex}
          />
        ))}
      </tbody>
    </StyledTable>
  );
};